import React, { useEffect, useState } from 'react';
import { LIVEDETECT_BASE as BASE } from './useLatestDetection';

const fmtEpoch = (epochS) => {
  if (!epochS) return '';
  try {
    return new Date(epochS * 1000).toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return '';
  }
};

const LiveDetectLightbox = ({ frames, initialIndex = 0, onClose }) => {
  const [idx, setIdx] = useState(initialIndex);

  useEffect(() => {
    setIdx(initialIndex);
  }, [frames, initialIndex]);

  useEffect(() => {
    if (!frames || frames.length === 0) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') setIdx(i => Math.max(0, i - 1));
      else if (e.key === 'ArrowRight') setIdx(i => Math.min(frames.length - 1, i + 1));
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [frames, onClose]);

  if (!frames || frames.length === 0) return null;
  const frame = frames[idx];
  if (!frame) return null;

  const hasPrev = idx > 0;
  const hasNext = idx < frames.length - 1;
  const hasNav = frames.length > 1;

  return (
    <div className="livedetect-lightbox" onClick={onClose}>
      <div className="livedetect-lightbox-inner" onClick={(e) => e.stopPropagation()}>
        <button className="livedetect-lightbox-close" onClick={onClose} title="Schließen (ESC)">
          <i className="fa fa-times"></i>
        </button>

        <div className="livedetect-lightbox-image-wrap">
          {hasNav && (
            <button
              className="livedetect-lightbox-nav livedetect-lightbox-prev"
              onClick={() => setIdx(i => Math.max(0, i - 1))}
              disabled={!hasPrev}
              title="Vorheriges Bild (←)"
            >
              <i className="fa fa-chevron-left"></i>
            </button>
          )}
          <img src={`${BASE}/ring/${frame.image}`} alt="Erkannter Zug" />
          {hasNav && (
            <button
              className="livedetect-lightbox-nav livedetect-lightbox-next"
              onClick={() => setIdx(i => Math.min(frames.length - 1, i + 1))}
              disabled={!hasNext}
              title="Nächstes Bild (→)"
            >
              <i className="fa fa-chevron-right"></i>
            </button>
          )}
        </div>

        <div className="livedetect-lightbox-meta">
          {hasNav && (
            <span className="livedetect-lightbox-counter">
              {idx + 1} / {frames.length}
            </span>
          )}
          <span><i className="fa fa-clock-o"></i> {fmtEpoch(frame.epoch)}</span>
          {frame.confidence != null && (
            <span className="livedetect-lightbox-conf">{Math.round(frame.confidence * 100)}%</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveDetectLightbox;
